











import { Component, Prop, Vue } from "vue-property-decorator";
import { ConcisenessRepetition } from "../../../types/NewResults";

// import AssetsMixin from "@/AssetsMixin";
// import Card from "../Card.vue";

@Component({
  components: {}
})
export default class Repetition extends Vue {
  @Prop() private fillerwpercent!: Number;
}
